exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.v-data-table>.v-data-table__wrapper>table>tbody>tr>td:last-child { height: auto\n}\n", ""]);

// exports
